import { z } from 'zod';

import { FormFields } from '@features/users/adminPanel/components/FormFields/FieldTypes.ts';

export const formSchema = z.object({
  [FormFields.INVOICING_EMAIL]: z
    .string({
      required_error: 'errorMessages.required',
    })
    .email({
      message: 'errorMessages.invalidEmail',
    }),
  [FormFields.VAT_NUMBER]: z
    .string({
      required_error: 'errorMessages.required',
    })
    .regex(/^\d+$/, {
      message: 'errorMessages.numericalValueRequired',
    })
    .length(11, {
      message: 'errorMessages.vatNumberMustBe11Digits',
    }),
});

export type FormValues = z.infer<typeof formSchema>;
